import { useMemo } from "react";
import AppBox from "../AppBox/AppBox";
import ContentNode from "../ContentNode/ContentNode";
import TulipCircleDiagram from "../../../../../svgs/TulipCircleDiagram.svg";
import "./Layer.css";

const Layer = ({
  layerData = {},
  selectedNode,
  setSelectedNode,
  selectedJourney,
}) => {
  const { id, height, width, nodes = [], image, name } = layerData;

  const isContentNode = useMemo(
    () => id === "eventBroker" || id === "dataWarehouse",
    [id]
  );
  const isSelected = useMemo(() => selectedNode?.id === id, [selectedNode, id]);
  const isHighlighted = useMemo(
    () => selectedJourney?.nodes?.some((n) => n === id),
    [selectedJourney, id]
  );

  const textStyle = useMemo(
    () => ({
      textAlign: nodes.length > 0 ? "left" : "center",
      padding: nodes.length > 0 ? "14px" : "0px",
    }),
    [nodes]
  );

  const backgroundColor = useMemo(() => {
    if (isHighlighted) return isSelected ? "#75bcc7" : "#b6dce1";
    return isSelected ? "#CCCCCC" : "#FFFFFF";
  }, [isHighlighted, isSelected]);

  const boxStyle = useMemo(
    () => ({
      height,
      width,
      marginBottom: "18px",
      display: "flex",
      border: nodes.length > 0 ? "3.5px solid #00263E" : "3.5px solid #135191",
      borderWidth: id === "tuliplayer" ? "4.5px" : "3.5px",
      zIndex: isContentNode ? "3" : "",
      cursor: isContentNode ? "pointer" : "default",
      background: backgroundColor,
      boxShadow: isSelected ? "0px 0px 0px 1px #135191" : "none",
    }),
    [height, width, nodes, id, isContentNode, backgroundColor, isSelected]
  );

  const handleClick = (e) => {
    if (isContentNode) {
      e.stopPropagation();
      setSelectedNode(layerData);
    }
  };

  return (
    <div
      className={`solid-box ${isContentNode ? "content-node" : ""} ${
        isHighlighted ? "highlight-node" : ""
      }`}
      style={boxStyle}
      onClick={handleClick}
    >
      <h4 style={textStyle}>{name}</h4>

      {nodes.length > 0 &&
        nodes.map((item) => (
          <ContentNode
            key={item.id}
            node={item}
            selectedNode={selectedNode}
            setSelectedNode={setSelectedNode}
            selectedJourney={selectedJourney}
          />
        ))}

      {image && (
        <div className="image-box">
          <img
            width={image.width}
            src={TulipCircleDiagram}
            alt="Tulip Center"
            style={{
              position: "absolute",
              top: image.top,
              left: image.left,
              zIndex: "2",
            }}
          />
          {(image.apps || []).map((app) => (
            <AppBox key={app.id} app={app} />
          ))}
        </div>
      )}
      {id === "tuliplayer" &&
        (layerData.textBoxes || []).map((item) => (
          <span
            className="text-box"
            key={item.id}
            style={{
              top: item.top,
              left: item.left,
              width: item.width,
            }}
          >
            {item.title}
          </span>
        ))}
    </div>
  );
};

export default Layer;
